export const TiposTransaccion = [
    {text: 'APERTURA DE CUENTA', value: 'APERTURA DE CUENTA'},
    {text: 'PAGO DE INSCRIPCION', value: 'PAGO DE INSCRIPCION'},
    {text: 'PAGO DE MENSUALIDAD', value: 'PAGO DE MENSUALIDAD'},
    {text: 'PAGO DE IMPRESION DE CERTIFICACIONES', value: 'PAGO DE IMPRESION DE CERTIFICACIONES'},
    {text: 'SOLICITUD DE IMPRESCION DE CERTIFICACIONES', value: 'SOLICITUD DE IMPRESCION DE CERTIFICACIONES'},
    {text: 'SOLICITUD DE EXAMEN DE RECUPERACION', value: 'SOLICITUD DE EXAMEN DE RECUPERACION'},
    {text: 'PAGO DE EXAMEN DE RECUPERACION ', value: 'PAGO DE EXAMEN DE RECUPERACION '},
]